import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SmartCapitalizePipe } from '../../../utils/pipes/smart-capitalize.pipe';
import { ModeloVehiculo } from '../../../types/vehicle.types';
import { toSlug } from '../../../utils/slugs/slug.utils';

@Component({
  selector: 'allas-modelos-seleccion',
  imports: [CommonModule, RouterModule, SmartCapitalizePipe],
  template: `
    <div class="mb-12 fs-condensed">
      <h2 class="text-2xl font-bold text-gray-900 mb-8">
        SELECCIONAR MODELO PARA {{ marca().toUpperCase() }}
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        @for (modelo of modelos(); track modelo.modelo) {
        <a
          [routerLink]="getModeloLink(modelo.modelo)"
          class="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-200 hover:border-red-300 hover:shadow-lg transition-all duration-300 overflow-hidden"
        >
          <div class="flex items-center space-x-4">
            <span
              class="font-medium text-gray-900 group-hover:text-red-600 transition-colors"
            >
              {{ modelo.marca | smartCapitalize }}
              {{ modelo.modelo | smartCapitalize }}
            </span>
          </div>
          <div class="text-gray-400 group-hover:text-red-500 transition-colors">
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </div>
        </a>
        }
      </div>
    </div>
  `,
})
export class ModelosSeleccionComponent {
  @Input() marca = signal<string>('');
  @Input() modelos = signal<ModeloVehiculo[]>([]);

  getModeloLink(modelo: string): string[] {
    if (this.marca()) {
      const modeloSlug = toSlug(modelo);
      return ['/repuestos', 'v', toSlug(this.marca()), modeloSlug];
    }
    return ['/repuestos'];
  }
}
